/*
Suresh Peddavoora 10/28/2022 3075154998  Added Class Name for Table Enhancements
saikrishna 11/03/2022 3075154998 Changed PaginationOptions
Akhila 11/23/2022 3075154998 Removed Global search
Raghu 11/28/2022 3075154998 Table Footer fixes
Ashraf 01/02/2023 3075154998 renamed usage header title
Ashraf 01/09/2023 3075154998 fixed usage records issue
Raghu 02/21/2023 3075154998 changed buttons color
suresh peddavoora 02/27/2023 3075154998 New UI changes and fields alignments
Akhila 04/25/2023 3075154998 rename the usage dialoge box
*/
import React, {useContext} from 'react';
import {ThemeContext} from '../../themes/ThemeProvider';
import {Button, TablePagination} from '@material-ui/core';
// import MaterialTable from "material-table";
import {tableIcons} from '../TableIcons';
import DialogBox from '../DialogBox';
import GuiTable from '../FormComponents/GuiTable';
import {defaultRows, tablePageRows} from '../../constants/ReusableTablePagination';
import capitalize from '../../util/Capitalize';
import {modulesText} from '../../util/Content';
const OverrideRule = ({
  dialogTitle,
  dialogOpen,
  dialogClose,
  data,
  title,
  handleOverrideClose,
  handleOverrideSubmit,
  type,
  isOverRide = true,
  isDataTranformDelete,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const values = [];
  data &&
    Object.entries(data)?.forEach(([key, value]) => {
      value?.length > 0 &&
        value?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el?.code,
            description: el?.description ?? '',
            repositoryFields: el?.repositoryFields ?? '',
          });
        });
    });

  const columns = [
    {
      title:modulesText,
      field: 'frameWork',
      maxWidth: 350,
      render: (rowData) => {
        return rowData?.frameWork ? capitalize(rowData?.frameWork) : '';
      },
    },
    {
      title: 'Name',
      field: 'codes',
      maxWidth: 250,
    },
    {
      title: 'Description',
      field: 'description',
      maxWidth: 300,
    },
  ];

  return (
    <DialogBox open={dialogOpen} dialogClose={dialogClose} title={dialogTitle} maxWidth="lg">
      <div className="col override-popup ">
        <div className="custom-table global-field-table new-standard-textfields">
          <GuiTable
            title={title}
            columns={columns}
            icons={tableIcons}
            data={values}
            textAlign="left"
            options={{
              toolbar: true,
              search: false,
              pageSize: defaultRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
              pageSizeOptions: tablePageRows,
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </div>
      <div className="message-buttons new-standard-textfields">
        {isOverRide ? <div>Do you want to override?</div> : null}
        {isOverRide ? (
          <div className="mt-2">
            <Button
              variant="outlined"
              className={`reset-btn mx-1 ${classes.buttonRoot}`}
              onClick={handleOverrideClose}
            >
              No
            </Button>
            <Button
              type="button"
              variant="outlined"
              className={`search-btn mx-1 ${classes.buttonRoot}`}
              onClick={handleOverrideSubmit}
            >
              Yes
            </Button>
          </div>
        ) : (
          <div>
            <Button
              variant="outlined"
              className={`reset-btn mx-1 ${classes.buttonRoot}`}
              onClick={dialogClose}
            >
              Close
            </Button>
          </div>
        )}
      </div>
    </DialogBox>
  );
};

export default OverrideRule;
